export default __webpack_public_path__ + "static/media/Rule1.b3a9548b.png";